import { useRef, useState } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';

import { AssetTooltip } from '../components/asset-tooltip';
import { DataPreload } from '../components/data-preload';
import { Filters } from '../components/filters';
import { Map } from '../components/map';
import { MapDataLoader } from '../components/map-data-loader';
import { MapSideLoading } from '../components/map-side-loading';
import { RackInfoSidebar } from '../components/rack-info-sidebar';
// import { Settings } from '../components/settings';
import { AssetTooltipProvider } from '../providers/asset-tooltip';
import { AssetsFiltersProvider } from '../providers/assets-filters';
import { SettingsProvider } from '../providers/settings';
import { ViewFiltersProvider } from '../providers/view-filters';

export function SiteviewPage() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <AssetTooltipProvider>
      <AssetsFiltersProvider>
        <ViewFiltersProvider>
          <SettingsProvider>
            <DataPreload>
              <FullPageContent className="relative" testId="3d-view-page">
                <div ref={containerRef} className="absolute inset-0 size-full">
                  <MapDataLoader>
                    <div
                      className="absolute inset-0 transition-all duration-300 ease-in-out"
                      style={{ right: isSidebarOpen ? '384px' : '0px' }}
                    >
                      <Map />
                      <MapSideLoading />
                    </div>
                    <div className="pointer-events-none absolute inset-0 z-50">
                      <AssetTooltip containerRef={containerRef} />
                    </div>
                    <div className="absolute inset-y-0 right-0">
                      <RackInfoSidebar
                        isOpen={isSidebarOpen}
                        onToggle={setIsSidebarOpen}
                      />
                    </div>
                  </MapDataLoader>
                </div>
                <div className="absolute left-6 top-6 w-full max-w-sm">
                  <Filters />
                </div>

                {/* <div className="absolute right-6 top-6 w-full max-w-sm">
                  <Settings />
                </div> */}
              </FullPageContent>
            </DataPreload>
          </SettingsProvider>
        </ViewFiltersProvider>
      </AssetsFiltersProvider>
    </AssetTooltipProvider>
  );
}
